<template>
  <el-popover
    v-model="visiblePopover"
    placement="left"
    title="备注"
    width="200"
    trigger="hover"
    @show="showPopvover"
    @hide="noShowReviseRemarkTextAreaWhenHide"
  >
    <div v-if="showReviseRemark">
      <!-- {{ booking_detial.booking_remark }} -->
      {{ remarkText }}
    </div>
    <div v-else>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4 }"
        placeholder="请输入内容"
        v-model="remarkText"
      >
      </el-input>
      <div style="margin-top: 10px">
        <el-button @click="cancleReviseRemark" size="mini">取消修改</el-button>
        <el-button
          @click="submitReviseRemark(booking_detial.booking_no)"
          size="mini"
          type="primary"
          >提交修改</el-button
        >
      </div>
    </div>

    <el-button
      size="mini"
      class="remark_line_button"
      slot="reference"
      @click="reviseRemarkButton(booking_detial.booking_remark)"
      >备注：{{ booking_detial.booking_remark }}</el-button
    >
  </el-popover>
</template>

<script>
export default {
  name: "popover-textarea",
  data() {
    return {
      showReviseRemark: true, // 显示修改备注
      visiblePopover: false,
      remarkText: this.booking_detial.booking_remark, // 备注内容
    };
  },
  props: {
    booking_detial: Object,
  },
  watch: {
    booking_detial(newValue) {
      this.remarkText = newValue.booking_remark;
    },
  },

  methods: {
    showPopvover() {
      console.log(this.remarkText);
    },
    noShowReviseRemarkTextAreaWhenHide() {
      // 弹出框消失时，隐藏输入框
      this.showReviseRemark = true;
    },
    cancleReviseRemark() {
      this.showReviseRemark = true;
    },
    reviseRemarkButton(value) {
      // 点击修改按钮的时候
      this.showReviseRemark = false;
      this.remarkText = value;
    },
    submitReviseRemark(value) {
      // 提交备注
      this.$http
        .get(`/booking/remark?remark=${this.remarkText}&booking_id=${value}`)
        .then((res) => {
          console.log(res);
          const { data, errno, errmsg } = res.data;
          if (errno == "0") {
            this.showReviseRemark = false;
            this.visiblePopover = false;
            this.$notify({
              title: "成功",
              message: errmsg,
              type: "success",
            });
            this.booking_detial.booking_remark = data;
          }
        });
    },
  },
};
</script>

<style>
</style>